export const KPI_LANDING_ZONE_REQUEST = 'KPI_LANDING_ZONE_REQUEST';
export const KPI_LANDING_ZONE_SUCCESS = 'KPI_LANDING_ZONE_SUCCESS';
export const KPI_LANDING_ZONE_FAILURE = 'KPI_LANDING_ZONE_FAILURE';

export const CAMPAIGNS_LANDING_ZONE_REQUEST = 'CAMPAIGNS_LANDING_ZONE_REQUEST';
export const CAMPAIGNS_LANDING_ZONE_SUCCESS = 'CAMPAIGNS_LANDING_ZONE_SUCCESS';
export const CAMPAIGNS_LANDING_ZONE_FAILURE = 'CAMPAIGNS_LANDING_ZONE_FAILURE';

export const CAMPAIGN_LANDING_ZONE_REQUEST = 'CAMPAIGN_LANDING_ZONE_REQUEST';
export const CAMPAIGN_LANDING_ZONE_SUCCESS = 'CAMPAIGN_LANDING_ZONE_SUCCESS';
export const CAMPAIGN_LANDING_ZONE_FAILURE = 'CAMPAIGN_LANDING_ZONE_FAILURE';

export const RESET_CAMPAIGN_SUCCESS = 'RESET_CAMPAIGN_SUCCESS';
